const BASE_URL = '/api/loan-editor-custom-forms';

export class LoanEditorCustomFormsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLoanEditorCustomForms({ includeGlobal = true, includeDeleted = false } = {}) {
    return this.#http.get(BASE_URL, {
      params: { includeGlobal, includeDeleted },
    });
  }

  async getLoanEditorCustomForm({ id, includeGlobal = true }) {
    return this.#http.get(`${BASE_URL}/${id}`, {
      params: { includeGlobal },
    });
  }

  async createLoanEditorCustomForm(data) {
    return this.#http.post(BASE_URL, data);
  }

  async updateLoanEditorCustomForm({ id, patch }) {
    return this.#http.put(`${BASE_URL}/${id}`, patch);
  }

  async updateLoanEditorCustomFormLayout({ id, layout }) {
    return this.#http.put(`${BASE_URL}/${id}/layout`, layout);
  }

  async deleteLoanEditorCustomForm({ id }) {
    return this.#http.delete(`${BASE_URL}/${id}`);
  }
}
